import { render, staticRenderFns } from "./CustomerOnetimeForm.vue?vue&type=template&id=774d03bc&scoped=true"
import script from "./CustomerOnetimeForm.vue?vue&type=script&lang=js"
export * from "./CustomerOnetimeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d03bc",
  null
  
)

export default component.exports